"use strict";

exports.__esModule = true;
exports["default"] = getMarker;
function getMarker(_ref) {
  var type = _ref.type,
    letter = _ref.letter,
    fillColor = _ref.fillColor;
  return {
    path: 'M5.763 1.107C2.089 2.377-.204 5.886.073 9.814c.065.922.292 2.096.505 2.61.433 1.049 7.466 11.728 7.723 11.728.257 0 7.29-10.68 7.723-11.728.212-.514.44-1.688.505-2.61.423-6.002-5.27-10.606-10.766-8.707z',
    fillColor: fillColor ? fillColor : 'black',
    fillOpacity: 1,
    strokeWeight: 0,
    rotation: 0,
    scale: 2,
    label: letter
  };
}